import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import ReactPlayer from "react-player"
import splash_image from "../../images/splash_header.jpg"
import {
  Button,
  Grid,
  LangSelector,
  RichDescription,
  RichTitle,
} from "../index"
import Img from "gatsby-image"
import Typography from "@material-ui/core/Typography"
import { injectIntl } from "react-intl"

const useStyles = makeStyles(theme => {
  return {
    root: {
      position: "fixed",
      left: 0,
      top: 0,
      zIndex: 1301,
      bottom: 0,
      right: 0,
      background: theme.palette.white.main,
    },
    rootSub: props => ({
      display: "flex",
      flexDirection: "column-reverse",
      height: "100vh",
      position: "relative",
      zIndex: 0,
      [theme.breakpoints.down("md")]: {
        height: "100vh",
        maxHeight: "none",
        minHeight: 0,
      },
    }),
    grid: {
      height: "100vh",
      // overflow: "visible",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap-reverse",
      },
    },
    gridItem: {
      height: "100vh",
    },
    copy: props => ({
      margin: "0 auto",
      height: "100%",
      position: "fixed",
      width: "50%",
      left: 0,
      right: 0,
      top: 0,
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
      flexDirection: "column",
      padding: theme.spacing(4, 1),
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        width: "70%",
      },
    }),
    staticCopyText: {
      marginBottom: 32,
      textAlign: "center",
      flexDirection: "row",
      fontSize: theme.spacing(3),
      fontWeight: 200,
    },
    imageWrapper: {
      alignItems: "stretch",
      height: "100vh",
      display: "flex",
      "& video": {
        objectFit: "cover",
      },
    },
    image: {
      height: "100%",
      objectFit: "cover",
      width: "100%",
    },
    logoImage: {
      width: theme.spacing(12.5),
      height: theme.spacing(15),
      margin: "0 auto 0 auto",
      display: "inline-block",
    },
    logoImg: {
      height: theme.spacing(12.5),
    },
    buttonDiv: {
      display: "flex",
      "flex-direction": "row",
    },
    select: {
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      color: theme.palette.white.main,
    },
    langSelector: {
      fontSize: theme.spacing(1.625),
      fontFamily: theme.typography.button.fontFamily,
      border: "solid 1px #fff",
      padding: "3px 5px",
      marginTop: "2px",
      marginRight: theme.spacing(3),
      position: "relative",
      bottom: theme.spacing(0.125),
      color: theme.palette.white.main,
    },
    video: {
      width: "100vw",
      height: "100%",
      "@supports (-ms-ime-align: auto)": {
        width: "auto",
        height: "100%",
        marginLeft: "auto",
        marginRight: "auto",
      },
    },
  }
})

export default injectIntl(props => {
  const classes = useStyles(props)
  const consts = require("../../constants/randomConsts")
  const { intl } = props
  const Logo = props.logo
  const slide = {
    copyText: props.copyText,
    titleText: props.titleText,
    mediaSrc: props.mediaSrc,
    buttonText: props.buttonText,
    buttonColor: props.buttonColor,
    static: true,
  }
  let isStatic = true

  return (
    <div>
      <div className={classes.root} data-cy="hero">
        <div className={classes.rootSub}>
          <Grid
            xs={0}
            container
            noMaxWidth
            noMargins
            wrapReverse
            className={classes.grid}
          >
            <Grid item lg={12}>
              <div className={classes.imageWrapper}>
                <div>
                  {props.mediaType === "Video" && (
                    <video
                      className={classes.video}
                      preload
                      loop
                      autoPlay
                      muted
                    >
                      <source src={props.mediaSrc} />
                    </video>
                  )}
                  {props.mediaType === "Vimeo URL" && (
                    <ReactPlayer
                      url={props.mediaSrc}
                      controls
                      playing
                      volume={0}
                      width="100%"
                      height="100%"
                    />
                  )}
                  {props.mediaType === "Image" && (
                    <img
                      className={classes.image}
                      src={props.mediaSrc}
                      alt={""}
                    />
                  )}
                </div>

                <div className={classes.copy}>
                  <div className={classes.logoImage}>
                    <img
                      src={Logo}
                      className={classes.logoImg}
                      data-cy="header-logo"
                      alt="Logo"
                    />
                  </div>
                  {slide.titleText.content && (
                    <div
                      className={
                        isStatic ? classes.staticCopyText : classes.copyText
                      }
                    >
                      <RichTitle titleText={slide.titleText} />
                    </div>
                  )}
                  <div
                    className={
                      isStatic ? classes.staticCopyText : classes.copyText
                    }
                  >
                    {slide.copyText && (
                      <RichDescription copyText={slide.copyText} />
                    )}
                  </div>
                  <div className={classes.buttonDiv}>
                    {/*<LangSelector
                      slug={props.pageContext.slug}
                      response={props.response}
                      locale={props.intl.locale}
                      className={classes.langSelector}
                      select={classes.select}
                      mobile={true}
                      fontSize={15}
                      isSplash
                    />*/}
                    <Button
                      className={classes.enableButton}
                      color={
                        slide.buttonColor
                          ? slide.buttonColor
                          : consts.colorGreen
                      }
                      onClick={props.removeSplash}
                    >
                      {slide.buttonText && (
                        <RichDescription copyText={slide.buttonText} />
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})
